module.exports = __webpack_public_path__ + "img/xmlogo.931d88e.png";